// Whether some other surface has asked the roster shell to open the Team modal.
//
// The same shape and the same reasoning as `settingsPanel.ts`: Team is now an overlay opened from the
// account chip, and three other places offer a "Manage team" door (the two roster empty states and the
// artist-required gate). Threading an opener prop from the shell down through every one of them would put
// the shell in the middle of surfaces that otherwise know nothing about it, so this is a one-field store —
// UI state only, imperatively settable from any depth, no prop-threading and no second context provider.
//
// The shell subscribes and CLEARS it once consumed, which is what keeps it a REQUEST rather than a second
// source of truth for "is Team open".
import { create } from "zustand";
import { registerStoreReset } from "./stores.js";

interface TeamPanelState {
  requested: boolean;
  request: () => void;
  consume: () => void;
  reset: () => void;
}

export const useTeamPanel = create<TeamPanelState>((set) => ({
  requested: false,
  request: () => set({ requested: true }),
  consume: () => set({ requested: false }),
  reset: () => set({ requested: false }),
}));

// Scorch on org/band switch + logout — a pending "open Team" from the previous tenant must not fire over
// the new one (stores.ts).
registerStoreReset(() => useTeamPanel.getState().reset());

/** Imperative opener for non-component call sites. */
export function openTeamPanel(): void {
  useTeamPanel.getState().request();
}
